import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment-timezone';
import {AutoSked} from 'src/app/schedule/shared/model/autosked';
import {TimezoneService} from 'src/app/services/timezone.service';
import {RruleService} from 'src/app/shared/services/rrule.service';

@Pipe({
  name: 'autoskedTimeDisplay',
  standalone: true,
})
export class AutoskedTimeDisplayPipe implements PipeTransform {
  constructor(
    private timezoneService: TimezoneService,
    private rruleService: RruleService
  ) {}

  transform(autoSked: AutoSked): unknown {
    // Extract timezone using rrule's built-in parser
    const rruleTimezone = autoSked.rrule ? this.rruleService.parseTimezoneFromRRule(autoSked.rrule) : null;

    const userTimezone = this.timezoneService.getTimeZone();

    // Convert from rrule timezone to user timezone
    const startTime = moment
      .tz(autoSked.start, 'HH:mm', rruleTimezone || userTimezone)
      .tz(userTimezone)
      .format('h:mm A');

    const endTime = moment
      .tz(autoSked.end, 'HH:mm', rruleTimezone || userTimezone)
      .tz(userTimezone)
      .format('h:mm A');

    return `${startTime} - ${endTime}`.replace(/:00/g, '');
  }
}
